module.exports = __webpack_public_path__ + "static/t&d-mobile-60f826f0a784cec4372e45eccde35152.png";